var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    borders = _ref.borders;
  return {
    itemContainerColor: colors.licorice,
    itemContainerPadding: spacing.xSmall,
    itemContainerBorderWidth: borders.widthSmall,
    itemContainerBorderColor: colors.licorice,
    summaryMargin: spacing.small,
    summaryMarginLeft: spacing.medium
  };
};
export default generateComponentTheme;